import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { coOpActionCreators, CoOpActionKeys, UpdateCoOpRequest } from '..';
import { ICoOpRequest } from '../coOpInterfaces';
import { IEntityWithMessages } from '../../../services/HttpService';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateCoOpRequestSaga(action: UpdateCoOpRequest) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IEntityWithMessages<ICoOpRequest> =
    action.payload.coOpRequestId > 0
      ? yield call(api.updateCoOpRequest, action.payload)
      : yield call(api.createCoOpRequest, action.payload);

  if (response.value) {
    yield put(coOpActionCreators.setRequests([response.value]));
  }

  yield processMessages(response);
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpRequest() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_REQUEST, updateCoOpRequestSaga);
}
